import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yhgl",
  "use": "icon-yhgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yhgl\"><path d=\"M914.285714 802.857143q0 68.571429-41.714286 108.285714t-110.857143 39.714286l-499.428571 0q-69.142857 0-110.857143-39.714286t-41.714286-108.285714q0-30.285714 2-59.142857t8-62.285714 15.142857-62 24.571429-55.714286 35.428571-46.285714 48.857143-30.571429 63.714286-11.428571q5.142857 0 24 12.285714t42.571429 27.428571 61.714286 27.428571 76.285714 12.285714 76.285714-12.285714 61.714286-27.428571 42.571429-27.428571 24-12.285714q34.857143 0 63.714286 11.428571t48.857143 30.571429 35.428571 46.285714 24.571429 55.714286 15.142857 62 8 62.285714 2 59.142857zm-182.857143-510.285714q0 90.857143-64.285714 155.142857t-155.142857 64.285714-155.142857-64.285714-64.285714-155.142857 64.285714-155.142857 155.142857-64.285714 155.142857 64.285714 64.285714 155.142857z\" p-id=\"34025\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yhgl.svg
// module id = RvI3
// module chunks = 61